import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Entry } from 'contentful';
import { ImageContentType } from './picture.type';

@Component({
  selector: 'nibtravel-picture',
  templateUrl: 'picture.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PictureComponent {
  get mobileUrl(): string | undefined {
    return this.getUrl(this.imageMobile);
  }

  get lowResolutionUrl(): string | undefined {
    return this.getUrl(this.imageLowResolution);
  }

  get highResolutionUrl(): string | undefined {
    return this.getUrl(this.imageHighResolution);
  }

  @Input() imageMobile: string | Entry<ImageContentType> | undefined;
  @Input() imageLowResolution: string | Entry<ImageContentType> | undefined;
  @Input() imageHighResolution: string | Entry<ImageContentType> | undefined;

  private getUrl(image: string | Entry<ImageContentType> | undefined): string {
    if (typeof image === 'string') {
      return image;
    } else if (image?.sys) {
      // Contentful image property
      return image.fields?.file?.url?.startsWith('http')
        ? image.fields.file.url
        : `https:${image.fields?.file?.url}`;
    }
    return '';
  }
}
